import { SocketIoConfig } from 'ngx-socket-io';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

function apiUrl(): string & ('localhost' | '192.168.100.253' | '190.128.118.236') {
    const ref = window.location.href;
    if(ref.indexOf("localhost") > -1){
        return 'localhost'
    } else if(ref.indexOf("\\\\redmedica") > -1){
        return '192.168.100.253';
    } else if(ref.indexOf("192.") > -1){
        return '192.168.100.253';
    } else{ 
        return '190.128.118.236'
    }
}
export const environment = {
    production: false,
    hmr       : false,
    informesdUrl: 'http://190.128.118.236:83/informes',
    /* backendUrl:'https://192.168.100.253/vitalsoft', */
    backendUrl: 'http://190.128.118.236:83/vitalsoft',
    api: `https://${apiUrl()}:3000/`,
};
export const socketConf: SocketIoConfig = {
    options: {},
    url: `https://${apiUrl()}:3300/`
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
